<div class="tt-c-reviews-list-toolbar tt-c-toolbar">
  <div class="tt-c-toolbar__content-left tt-u-spacing--left--md">
    <tt-menu v-show="!showSearchField" class="tt-c-reviews-list-toolbar__sort">
      <tt-button slot="menuTrigger" type="toolbar" class="tt-c-reviews-list-toolbar__sort-trigger" :aria-label="$msg('reviewsList.sortReviews')">
        <span class="tt-c-reviews-list-toolbar__sort-text" v-html="sortByTitle"></span><tt-icon size="xxs" name="arrow-fill"></tt-icon><tt-icon size="sm" name="sort"></tt-icon>
      </tt-button>
      <tt-menu-list alignMenu="left" :menuItems="sortOptions" @menuItemSelected="sortOrderSelected" type="dropdown"></tt-menu-list>
    </tt-menu>

    <tt-menu v-show="!showSearchField" ref="filterMenu" class="tt-c-reviews-list-toolbar__filter tt-o-filter">
      <tt-button slot="menuTrigger" type="toolbar" :aria-label="$msg('reviewsList.filterReviews')" class="tt-c-reviews-list-toolbar__filter-trigger"><span class="tt-c-reviews-list-toolbar__filter-text" v-html="filtersLabel"></span><tt-icon name="controls" size="sm" class="tt-o-filter__icon"></tt-icon></tt-button>
      <tt-filter-list :filters="filters" :filterStore="filterStore" :style="{ left: filterMenuLeftPos + 'px' }"></tt-filter-list>
    </tt-menu>

    <div class="tt-c-reviews-list-toolbar__search" :class="{ 'tt-c-reviews-list-toolbar__search--active': showSearchField }">
      <tt-button v-show="!showSearchField" ref="openSearchTrigger" class="tt-c-reviews-list-toolbar__search-action" @click="openSearch" type="toolbar" :aria-label="$msg('reviewsList.searchReviews')"><span class="tt-c-reviews-list-toolbar__search-text" v-html="$msg('reviewsList.search')"></span><tt-icon name="search" size="sm"></tt-icon></tt-button>
      <tt-button v-show="showSearchField" type="icon" class="tt-c-reviews-list-toolbar__search-close" :aria-label="$msg('searchField.close')" @click="closeSearch">
        <tt-icon name="back-arrow" size="xs"></tt-icon>
      </tt-button>
      <label for="tt-c-reviews-list-toolbar-search-field" class="tt-u-clip-hide" v-html="$msg('reviewsList.searchReviews')"></label>
      <tt-search-field v-show="showSearchField"       
                       ref="searchFieldComponent"
                       @input="updateSearchText"
                       :multiline="false"
                       :materialStyle="true"
                       class="tt-c-reviews-list-toolbar__search-field"
                       fieldId="tt-c-reviews-list-toolbar-search-field"
                       describedBy=""></tt-search-field>
    </div>
    
  </div>
  <div class="tt-c-toolbar__content-right">
    <tt-button v-if="!hideWriteReview && !isLaunchingWriteReview" class="tt-c-toolbar__write-review" type="primary" @click="writeReview">
      <span class="tt-u-show-until--md" v-html="$msg('reviewsList.writeReview.mobile')"></span>
      <span class="tt-u-hide-until--md" v-html="$msg('reviewsList.writeReview')"></span>
    </tt-button>
    <div v-else-if="!hideWriteReview && isLaunchingWriteReview" class="tt-o-spinner tt-o-spinner--submit"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/reviews-list/reviews-list-toolbar.html